var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponent(_vm.item),{tag:"component",attrs:{"item":_vm.item,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }